import Responsive from './Responsive';
import Swiper from 'swiper';

module.exports = function() {
	const r = new Responsive();

	const wrapper = $('.slide_wrapper-card_list_bgimg');
	const target = '#js-slide-card_list_bgimg';
	let slide_obj = undefined;
	let slide_num = $(target).find('li').length;

	$('.area').each(function(){
		if($(this).find(wrapper).length > 0){
			$(this).css({'overflow':'hidden'});
		}
	});

	let slide_options = {
		speed:800,
		slidesPerView: 'auto',
		autoplay: 2000,
		spaceBetween: 0,
		loop:true,
		centeredSlides:true,
		onSlideChangeEnd : (s) => {s.fixLoop();}
	};

	if(slide_num > 1 ){
		$(window).on('load resize',function(){
			if(!r.state()()){
				if(slide_obj != undefined){
					slide_obj.destroy( true, true );
					slide_obj = undefined;
				}
			}else{
				if(slide_obj == undefined){
					slide_obj = new Swiper(target,slide_options);
					$(wrapper).hover(function(){
						slide_obj.stopAutoplay();
					}, function(){
						slide_obj.startAutoplay();
					});
				}
			}

		});
	}


	wrapper.find('.card_list_bgimg-list')
	.on('mouseenter',function(){
		if(r.state()()){
			$(this).addClass('active-hover');
		}
	}).on('mouseleave',function(){
		if(r.state()()){
			$(this).removeClass('active-hover');
		}
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/slide_card_list_bgimg.js